<template>
	<v-row class="ma-0 pb-offset">
        <v-col cols="12" class="pa-0">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Altre Impostazioni</p>
                    <v-spacer></v-spacer>
                </v-card-title>                
                <v-divider></v-divider>
                <v-list three-line subheader class="background-2 pa-2">
                    <v-subheader>Scadenze</v-subheader>
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['disable_autogenerate']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Disattiva Generazione automatica Scadenze</v-list-item-title>
                            <v-list-item-subtitle>Disattiva la generazione automatica delle scadenze per clienti e fornitori durante l'emissione dei documenti di vendita e di acquisto.
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    
                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['disable_autogenerate_payments']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Disattiva Generazione automatica Pagamenti</v-list-item-title>
                            <v-list-item-subtitle>Disattiva la generazione automatica dei pagamenti dopo la generazione dei tracciati RIBA e SDD delle scadenze.
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item>
                        <v-list-item-action>
                            <v-checkbox color="primary" v-model="settings['enable_settlement']"></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Gestione esiti RIBA/SDD</v-list-item-title>
                            <v-list-item-subtitle>Dopo la generazione dei tracciati le scadenze restano aperte in attesa di esito, senza registrare i pagamenti. L'incasso o l'insoluto si registrano con l'azione "Esita Scadenze".
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="pa-2 mx-3" color="primary" @click.native="saveSettings">Salva</v-btn>
                </v-card-actions>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
	import SettingsOptionsMixin from '@/mixins/SettingsOptionsMixin.js';

    export default {
        name: 'deadlines-options',
		mixins: [SettingsOptionsMixin],
        props: {},
        data() {
            return {
                model: 'deadline',
                settings: {
                    'disable_autogenerate': false,
                    'disable_autogenerate_payments': false,
                    'enable_settlement': false,
                },
            }
        },
    }
</script>